var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C10.866 0 14 3.134 14 7C14 10.866 10.866 14 7 14C3.134 14 0 10.866 0 7C0 3.134 3.134 0 7 0ZM7 1.4C3.9072 1.4 1.4 3.9072 1.4 7C1.4 10.0928 3.9072 12.6 7 12.6C10.0928 12.6 12.6 10.0928 12.6 7C12.6 3.9072 10.0928 1.4 7 1.4ZM7 2.8C7.35899 2.8 7.65486 3.07023 7.69529 3.41837L7.7 3.5V6.71006L9.59497 8.60503C9.86832 8.87838 9.86832 9.32162 9.59497 9.59497C9.34265 9.84729 8.94557 9.8667 8.67097 9.6532L8.60503 9.59497L6.50503 7.49497C6.39566 7.38559 6.32619 7.2437 6.30607 7.09201L6.3 7V3.5C6.3 3.1134 6.61339 2.8 7 2.8Z",
    fill: "#D35258"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.135424edbac3cab7d306747641d936c1.svg";
export { ForwardRef as ReactComponent };